import type {IconSize} from '@Components/icon-v2/icon.types';
import type {FooterLeftActionProps} from '@Components/ai-prompt-box/components/ai-prompt-box-footer-left-actions/ai-prompt-box-footer-left-actions.types';

export type AiPromptBoxAspectRatioSelectorProps = FooterLeftActionProps;

export enum AspectRatioOrientation {
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape',
}

export enum PinnableAspectRatio {
  SQUARE = '1:1',
  PORTRAIT_2_3 = '2:3',
  PORTRAIT_3_4 = '3:4',
  PORTRAIT_4_5 = '4:5',
  PORTRAIT_9_16 = '9:16',
  LANDSCAPE_3_2 = '3:2',
  LANDSCAPE_4_3 = '4:3',
  LANDSCAPE_5_4 = '5:4',
  LANDSCAPE_16_9 = '16:9',
}

export const ASPECT_RATIO_OPTIONS: Record<AspectRatioOrientation, PinnableAspectRatio[]> = {
  [AspectRatioOrientation.PORTRAIT]: [
    PinnableAspectRatio.SQUARE,
    PinnableAspectRatio.PORTRAIT_2_3,
    PinnableAspectRatio.PORTRAIT_3_4,
    PinnableAspectRatio.PORTRAIT_4_5,
    PinnableAspectRatio.PORTRAIT_9_16,
  ],
  [AspectRatioOrientation.LANDSCAPE]: [
    PinnableAspectRatio.SQUARE,
    PinnableAspectRatio.LANDSCAPE_3_2,
    PinnableAspectRatio.LANDSCAPE_4_3,
    PinnableAspectRatio.LANDSCAPE_5_4,
    PinnableAspectRatio.LANDSCAPE_16_9,
  ],
};

export const ASPECT_RATIO_SELECTOR_MODAL_PANEL_ID = 'ai-prompt-box-aspect-ratio-selector-modal-panel';

export interface AspectRatioIconTriggerSizing {
  triggerClass: string;
  iconSize: IconSize;
}
